var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-between py-4"},[_c('h4',{staticClass:"font-weight-bold accent--text"},[_vm._v(_vm._s(_vm.$t('home_page.popular_title')))]),_c('v-btn',{staticClass:"text-none",attrs:{"text":"","color":"accent"},on:{"click":function($event){return _vm.goViewAllRecipe()}}},[_vm._v(_vm._s(_vm.$t('view_all')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }